<template>
  <div>
    <div v-if="!isCodeSend" class="enter__body-content">
      <div class="enter__body-title">Вход/Регистрация</div>

      <form class="enter__body-form" method="post" @submit.prevent>
        <div class="enter__phone-form">
          <div class="enter__body-text enter__body-text_top">Отправим СМС с кодом на номер телефона</div>

          <TheInput
            label="Номер телефона"
            v-model="credential.telephone"
            v-model:error="errors.telephone"
            type="text"
            maska="+7 (###) ###-##-##"
            update-model-on-input
          />
          <div class="field__form-bottom">
            <button
              v-if="timerCount === 0"
              @click="getCode"
              :disabled="!isSubmitEnabled"
              :class="{ disabled: !isSubmitEnabled }"
              class="btn close__modal-enter"
              type="submit"
            >
              <TheSpinner v-if="isLoader"/>Продолжить
            </button>

            <button v-else class="btn disabled" type="button">Получить новый код через&nbsp;<span v-text="timerCount"/>&nbsp;сек.</button>
          </div>
        </div>

        <div class="vk-login-wrapper">
          <div class="enter__body-text enter__body-text_bottom">
            Войти через
          </div>

          <VkLogin :disabled="!hasAcceptedPrivacy"/>
        </div>
      </form>
      <div class="enter__body-personal">
        <KrdCheckbox v-model="hasAcceptedPrivacy">
          Предоставляя персональные данные, Вы соглашаетесь<br />
          <!-- eslint-disable-next-line no-irregular-whitespace -->
          c <router-link :to="privacyRoute" target="_blank">условиями обработки персональных данных</router-link>
        </KrdCheckbox>
      </div>
    </div>


    <div v-if="isCodeSend"  class="enter__body-content">
      <div class="enter__body-title">Подтверждение</div>
      <div class="enter__body-text enter__body-text_top black">
        Мы отправили вам код подтверждения на номер <span v-text="credential.telephone"/> в СМС &nbsp;<a @click="handleChangeNumberClick">Изменить номер</a>
      </div>
      <form class="row" method="post"  @submit.prevent>
        <div style="display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 12px;">
        <v-otp-input
            ref="otpInput"
            input-classes="otp-input"
            :conditionalClass="['one', 'two', 'three', 'four']"
            separator=""
            inputType="letter-numeric"
            :num-inputs="4"
            v-model:value="credential.code"
            :should-auto-focus="true"
            :should-focus-order="true"
            @on-complete="login"
            @on-change="errors.code = null"
            :placeholder="['*', '*', '*', '*']"
        />
          <div v-if="isLoader" style="display: flex">Проверяем код &nbsp;<TheSpinner/></div>

          <AlertBox :is-show="errors?.code" :message="errors?.code" />
        </div>


      </form>

      <div class="field__form-bottom">
      <button
        v-if="timerCount === 0"
        @click="getCode(true)"
        class="btn"
        type="button"
      >
        <TheSpinner v-if="isLoader"/>
        Получить новый код
      </button>
        <button v-else class="btn disabled" type="button">Получить новый код через&nbsp;<span v-text="timerCount"/>&nbsp;сек.</button>
      </div>
      <VkLogin  v-if="timerCount === 0"/>
      <div class="enter__body-personal enter__body-personal_center">
        Предоставляя свои персональные данные, Вы соглашаетесь с <router-link :to="privacyRoute" target="_blank">условиями обработки персональных данных</router-link>
      </div>
    </div>


  </div>
</template>

<script>
import TheInput from "@/components/form/TheInput.vue";
import config from "@/config.js";
import TheSpinner from "@/components/TheSpinner.vue";
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import VOtpInput from "vue3-otp-input";
import VkLogin from "@/components/form/login/VkLogin.vue";
import KrdCheckbox from '@/components/element/Checkbox.vue'

const CODE_RESENT_TIMEOUT = 70
const REQUIRED_PROFILE_FIELDS = [
  'firstname',
  'email',
  'telephone',
  'gender',
  'custom_field'
]

export default {
  name: 'LoginForm',
  components: {VkLogin, TheSpinner, TheInput, VOtpInput, KrdCheckbox},
  data() {
    return {
      isLoader: false,
      errors: [],
      timerCount: 0,
      credential: {
        telephone: '',
        code: '',
      },
      isCodeSend: false,
      hasAcceptedPrivacy: false
    }
  },
  mounted() {
    this.timerCount = this.getTimeRemaining()
  },

  computed: {
    ...mapState({
      userData: state => state.user.user,
    }),
    ...mapGetters({
      privacyRoute: 'city/privacyRoute',
    }),

    isSubmitEnabled() {
      return !this.isLoader &&
        this.hasAcceptedPrivacy &&
        this.credential.telephone.replace(/[^0-9]/g, '').length === 11
    }
  },

  watch: {
    timerCount: {
      handler(value) {
        this.clearTimer()

        if (value > 0) {
          this.timer = setTimeout(() => {
            this.timerCount--;
          }, 1000);
        } else {
          localStorage.removeItem('loginTimerStartAt');
        }
      },
    }
  },

  destroyed() {
    this.clearCode()
    this.clearTimer()
  },

  methods: {
    ...mapMutations({
      'setUser': 'user/setUser',
      'setShowLoginModal': 'setShowLoginModal',
    }),

    ...mapActions('profileModal', ['setShowProfileModal']),

    startTimer() {
      this.timerCount = CODE_RESENT_TIMEOUT;
    },
    clearMaskArtefact(value) {
      if (value.length > 0) {
        value = value.replace(/[()]/g, '').replace(/[-\s]/g, '');
      }
      return value;
    },
    async getCode(isResend = false) {
      this.errors = [];
      this.isLoader = true;
      this.$API.request.post(config.hostname + '/index.php?route=api/login/getCode', {
        telephone: this.clearMaskArtefact(this.credential.telephone)
      }).then(() => {
        this.isCodeSend = true
        localStorage.setItem('loginTimerStartAt', Date.now())
        this.startTimer()
      }).catch((error ) => {
        if(!isResend){
          this.errors['telephone'] = error.response?.data?.error
          this.isCodeSend = false;
        }else {
          this.errors['code'] = error.response?.data?.error
        }
      }).finally(() => {
        this.isLoader = false;
      })
    },
    async login() {
      this.errors = [];
      this.isLoader = true;
      this.$API.request.post(config.hostname + '/index.php?route=api/login', {
        telephone: this.clearMaskArtefact(this.credential.telephone),
        code: this.credential.code.replace(/-/g, ''),
      }).then((response) => {
        this.timerCount = -1;
        this.setUser(response.customer);
        this.setShowLoginModal(false);
        this.showProfileWindow()
      }).catch((error ) => {
        this.errors = error.response?.data?.errors ?? []
      }).finally(() => {
        this.isLoader = false;
      })
    },

    getTimeRemaining() {
      return Math.max(
        (CODE_RESENT_TIMEOUT) - Math.ceil((Date.now() - parseInt(localStorage.getItem('loginTimerStartAt') || 0)) / 1000),
        0
      )
    },

    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },

    clearCode() {
      this.credential.code = ''
    },

    handleChangeNumberClick() {
      this.clearCode()
      this.isCodeSend = false
    },

    showProfileWindow() {
      const isProfileComplete = REQUIRED_PROFILE_FIELDS.every((field) => {
        return this.userData[field]
      }) && this.userData.custom_field['10']

      if (!isProfileComplete) {
        this.setShowProfileModal(true)
      }
    }
  }
}
</script>

<style lang="css" >
.otp-input-container{
  gap: 10px;
}
.otp-input {
  width: 48px;
  height: 56px;
  padding: 5px;
  border-radius: 12px;
  border: 1px solid #DCDDE0;
  text-align: center;
  font-weight: bold;
  font-size: 36px;
}

.otp-input:focus{
  border: 1px solid #9A2B0B;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
  color: white;
}
</style>